import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "pro"
const ProIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M17.303 10.755c.84 0 1.323.664 1.323 1.787v.01c0 1.123-.479 1.782-1.323 1.782-.845 0-1.328-.66-1.328-1.782v-.01c0-1.123.483-1.787 1.328-1.787M7.005 9.197c.903 0 1.43.484 1.43 1.328v.01c0 .845-.527 1.333-1.43 1.333H5.76v-2.67z" />
          <path
            fillRule="evenodd"
            d="M18.667 2A3.333 3.333 0 0 1 22 5.333v13.334A3.333 3.333 0 0 1 18.667 22H5.333A3.333 3.333 0 0 1 2 18.667V5.333A3.333 3.333 0 0 1 5.333 2zm-1.364 7.773c-1.587 0-2.569 1.05-2.569 2.764v.01c0 1.728.967 2.773 2.569 2.773 1.596 0 2.568-1.045 2.568-2.773v-.01c0-1.719-.976-2.764-2.568-2.764M4.5 8.167v7.046h1.26v-2.33h1.553c1.43 0 2.397-.947 2.397-2.353v-.01c0-1.41-.967-2.353-2.398-2.353zm9.146 1.621c-.704 0-1.192.337-1.373.908h-.083v-.82h-1.215v5.337h1.215v-3.1c0-.762.533-1.246 1.343-1.246.21 0 .41.03.606.068V9.848a2 2 0 0 0-.493-.059"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default ProIcon
